import { ConvertCropNameToKey } from "../../../helpers/Helpers";
import { getBothIssues } from "../../../helpers/getBothIssues";
import getListOfIssues from "../../../helpers/getListOfIssues";
import SummaryIssuesParcels from "./summaryIssuesParcels";
import SummaryIssuesTables from "./summaryIssuesTables";


const CropSummary = (props) => {
    const LastYearFilterKeyWord = "LastYear";

    const surveyData = props.surveyData;
    const cropName = props.cropName;
    const cropKey = props.surveyData.pests ? ConvertCropNameToKey(props.surveyData.pests, props.cropName) : props.surveyData.diseases ? ConvertCropNameToKey(props.surveyData.diseases, props.cropName) : null;
    const { listOfPests, listOfDiseases } = getBothIssues(surveyData, cropName);
    const listOfPestsCurrentYear = listOfPests.filter(pest => !pest.name.toLocaleLowerCase().trim().includes(LastYearFilterKeyWord.toLocaleLowerCase().trim()))
    const listOfDiseasesCurrentYear = listOfDiseases.filter(disease => !disease.name.toLowerCase().trim().includes(LastYearFilterKeyWord.toLocaleLowerCase().trim()))
    const listOfWeeds = (surveyData.weeds !== null && surveyData.weeds[cropKey] !== null) ? getListOfIssues(surveyData.weeds[cropKey], true) : [];
    let pestData = { notUse: [], inUse: [], futureUse: [] };
    let diseaseData = { notUse: [], inUse: [], futureUse: [] };
    let weedsData = { notUse: [], inUse: [], futureUse: [] };
    if (listOfPestsCurrentYear.length !== 0) {
        if(props.cropPestSummaryMeasures)
            pestData = props.cropPestSummaryMeasures(surveyData.pests[cropKey].controlMeasures, listOfPestsCurrentYear);
    }
    if (listOfDiseasesCurrentYear.length !== 0) {
        if (props.cropDiseaseSummaryMeasures)
            diseaseData = props.cropDiseaseSummaryMeasures(surveyData.diseases[cropKey].controlMeasures, listOfDiseasesCurrentYear);
    }
    if (listOfWeeds.length !== 0) {
        if (props.cropWeedsSummaryMeasures)
            weedsData = props.cropWeedsSummaryMeasures(surveyData.weeds[cropKey].controlMeasures, listOfWeeds);
    }
    return (
        <>
            <SummaryIssuesParcels landParcels={props.surveyData.landParcels} cropName={cropName}></SummaryIssuesParcels>
            <SummaryIssuesTables
                listOfPestsControls={surveyData?.pests ? surveyData?.pests[cropKey]?.controlMeasures : null}
                listOfDiseasesControls={surveyData?.diseases ? surveyData?.diseases[cropKey]?.controlMeasures : null}
                listOfWeedsControls={surveyData?.weeds ? surveyData?.weeds[cropKey]?.controlMeasures : null}
                listOfPests={listOfPestsCurrentYear}
                listOfDiseases={listOfDiseasesCurrentYear}
                listOfWeeds={listOfWeeds}
                pestData={pestData}
                diseaseData={diseaseData}
                weedsData={weedsData}
                crop={cropName}>
            </SummaryIssuesTables>
        </>
    );
};

export default CropSummary;